define('presentation/welcome/validators/onboardingAvailabilityValidator',[
        'constants/liveReceptionistScriptFollowUpConstants',
        'presentation/common/validation/commonValidator',
        'presentation/common/validation/validationRule'
    ],
    function() {
        return function() {
            let self = this;

            let _facade = null;
            let _viewModel = null;
            let _commonValidator = null;

            const CommonValidatorConstructor = require('presentation/common/validation/commonValidator');
            const ValidationRulesConstructor = require('presentation/common/validation/validationRule');

            const _followUpConstants = require('constants/liveReceptionistScriptFollowUpConstants');

            self.registerViewModel = (viewModel, facade) => {

                _viewModel = viewModel;
                _facade = facade;
                _commonValidator = new CommonValidatorConstructor(_viewModel);

                const validationRules = new ValidationRulesConstructor();
                validationRules.field("timeZone")
                    .addValidationKeyUp(_commonValidator.isStringWithValue)
                    .addValidationI18n(_commonValidator.isStringWithValue, 'onboardingAvailability:timeZoneRequired');
                validationRules.field("callerFollowUp")
                    .addValidationKeyUp(_validateCallerFollowUp)
                    .addValidationI18n(_validateCallerFollowUp, 'onboardingAvailability:pleaseMakeSelection');
                validationRules.field("callerFollowUpOther")
                    .addValidationKeyUp(_validateCallerFollowUpOther)
                    .addValidationI18n(_validateCallerFollowUpOther, 'onboardingAvailability:pleaseProvideResponse');
                validationRules.array("operatingHours")
                    .arrayField("openTime")
                    .addValidationI18n(_validateOperatingHours, 'onboardingAvailability:operatingHoursRequired');

                validationRules.validationGroupKeyUp('isValid', ['timeZone', 'callerFollowUp', 'callerFollowUpOther']);

                _commonValidator.setValidationRules(validationRules);
            };

            self.validate = () => {
                return _commonValidator.validate();
            };

            const _validateCallerFollowUp = (callerFollowUp) => {
                return _commonValidator.isStringWithValue(callerFollowUp) &&
                    callerFollowUp !== _followUpConstants.Unknown;
            };

            const _validateCallerFollowUpOther = (callerFollowUpOther) => {
                if (_viewModel.showCallerFollowUpOther()) {
                    return _commonValidator.isStringWithValue(callerFollowUpOther);
                }
                return true;
            };

            const _validateOperatingHours = (openTime, weekdaySchedule) => {
                if (_viewModel.shouldDisplayOperatingHours() !== true) {
                    return true;
                }
                if (weekdaySchedule.isOpen() !== true) {
                    return true;
                }
                return _commonValidator.isStringWithValue(openTime) ||
                    _commonValidator.isStringWithValue(weekdaySchedule.closeTime());
            };
        };
    });
